export const zerezesErpCode = {
  Protheus: 'protheus'
}